import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';

export interface Props {
  openModal: () => void;
  className?: string;
}

export const CommissionCreateButton: FC<Props> = ({
  openModal,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      view="b16-undisciplined-designers"
      withPaddings={false}
      onClick={openModal}
      className={className}
    >
      {t('common.addNew')}
    </Button>
  );
};
CommissionCreateButton.displayName = 'CommissionCreateButton';

export default CommissionCreateButton;
